import React, { useState, useEffect } from 'react';
import { styled } from '@mui/system';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import PropTypes from 'prop-types';

import useGetModifierGroups from 'hooks/useGetModifierGroups';

import {
  getButtonFontHoverColor,
  getButtonBackgroundHoverColor
} from 'styles/helpers/getThemeStyles';
import { QUICK_ADD_TO_CART_TIMEOUT } from 'base-ordering/constants/index';

const StyledAddIcon = styled(AddIcon)(({ theme }) => ({
  backgroundColor: theme.palette.button.background.main,
  fill: theme.palette.button.font.main,
  transition: 'color 250ms cubic-bezier(0.4, 0, 0.2, 1)',
  borderRadius: '50%',
  width: '1.25rem',
  height: '1.25rem',
  marginLeft: '10px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: getButtonBackgroundHoverColor(theme),
    fill: getButtonFontHoverColor(theme)
  }
}));

const StyledCheckIcon = styled(CheckIcon)(({ theme }) => ({
  backgroundColor: theme.palette.button.background.main,
  fill: theme.palette.button.font.main,
  transition: 'color 250ms cubic-bezier(0.4, 0, 0.2, 1)',
  borderRadius: '50%',
  width: '1.25rem',
  height: '1.25rem',
  marginLeft: '10px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: getButtonBackgroundHoverColor(theme),
    fill: getButtonFontHoverColor(theme)
  }
}));

const QuickAddToCart = ({
  upsellItem,
  handleQuickAddToCart,
  handleAddToCart,
  setFade = () => {}
}) => {
  const [clicked, setClicked] = useState(false);
  const modifiers = useGetModifierGroups(upsellItem.product);

  const handleQuickAddToCartWithAnimation = () => {
    setFade();

    return setTimeout(() => {
      handleQuickAddToCart(upsellItem);
    }, QUICK_ADD_TO_CART_TIMEOUT);
  };

  useEffect(() => {
    if (clicked) {
      if (modifiers.length) {
        handleAddToCart();
      } else {
        const timeout = handleQuickAddToCartWithAnimation();
        return () => clearTimeout(timeout);
      }
    }
  }, [clicked]);

  return !clicked ? (
    <StyledAddIcon
      aria-label="quick-add-to-cart"
      onClick={e => {
        setClicked(true);
      }}
    />
  ) : (
    <StyledCheckIcon aria-label="quick-add-to-cart-confirmation" />
  );
};

QuickAddToCart.propTypes = {
  upsellItem: PropTypes.object.isRequired,
  handleAddToCart: PropTypes.array.isRequired,
  handleQuickAddToCart: PropTypes.func.isRequired,
  setFade: PropTypes.func
};

export default QuickAddToCart;
